<div style="width: 500px">
  <aux-investigator-transaction-supporting-section
    #supportingSection
    [noteFormControl]="noteFormControl"
  />
</div>
